"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var GlobalHttp404ErrorPage_component_exports = {};
__export(GlobalHttp404ErrorPage_component_exports, {
  GlobalHttp404ErrorPage: () => GlobalHttp404ErrorPage,
  default: () => GlobalHttp404ErrorPage_component_default
});
module.exports = __toCommonJS(GlobalHttp404ErrorPage_component_exports);
var import_react = __toESM(require("react"));
var import_react_i18next = require("react-i18next");
var import_ScreenReaderOnlyText = require("../../../atoms/ScreenReaderOnlyText/ScreenReaderOnlyText.component");
var import_Tooltip = require("../../../atoms/Tooltip/Tooltip.component");
var import_GlobalHttp404ErrorPage = require("./GlobalHttp404ErrorPage.styled");
var _excluded = ["customErrorMessage"];
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r)
      return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t)
          return;
        f = false;
      } else
        for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true)
          ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r))
    return r;
}
function _objectWithoutProperties(e, t) {
  if (null == e)
    return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++)
      o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r)
    return {};
  var t = {};
  for (var n in r)
    if ({}.hasOwnProperty.call(r, n)) {
      if (e.includes(n))
        continue;
      t[n] = r[n];
    }
  return t;
}
var GlobalHttp404ErrorPage = function GlobalHttp404ErrorPage2(_ref) {
  var customErrorMessage = _ref.customErrorMessage, props = _objectWithoutProperties(_ref, _excluded);
  var videoRef = (0, import_react.useRef)(null);
  var _useState = (0, import_react.useState)(true), _useState2 = _slicedToArray(_useState, 2), videoPlaying = _useState2[0], setVideoPlaying = _useState2[1];
  var _useTranslation = (0, import_react_i18next.useTranslation)(), t = _useTranslation.t;
  var playPauseVideo = function playPauseVideo2() {
    if (!videoPlaying) {
      var _videoRef$current;
      (_videoRef$current = videoRef.current) === null || _videoRef$current === void 0 || _videoRef$current.play();
      setVideoPlaying(true);
    } else {
      var _videoRef$current2;
      (_videoRef$current2 = videoRef.current) === null || _videoRef$current2 === void 0 || _videoRef$current2.pause();
      setVideoPlaying(false);
    }
  };
  var videoPlayStatus = "Pause Animation";
  if (!videoPlaying) {
    videoPlayStatus = "Play Animation";
  }
  (0, import_react.useEffect)(function() {
    if (videoRef.current) {
      videoRef.current.play();
    }
  }, []);
  return /* @__PURE__ */ import_react.default.createElement(import_GlobalHttp404ErrorPage.StyledHttp404ErrorPageContainer, null, /* @__PURE__ */ import_react.default.createElement(import_GlobalHttp404ErrorPage.StyledActionsContainer, null, /* @__PURE__ */ import_react.default.createElement(import_GlobalHttp404ErrorPage.StyledErrorText, null, customErrorMessage || t("base_errorMessage_pageWentExtinct")), /* @__PURE__ */ import_react.default.createElement(import_GlobalHttp404ErrorPage.StyledErrorHeading, {
    level: 1
  }, t("base_constant_error"), " 404"), /* @__PURE__ */ import_react.default.createElement(import_GlobalHttp404ErrorPage.StyledButtonsContainer, null, props.actions && props.actions.length && props.actions.map(function(buttonDetails) {
    return /* @__PURE__ */ import_react.default.createElement(import_GlobalHttp404ErrorPage.StyledButton, {
      icon: buttonDetails.icon,
      variant: buttonDetails.variant === "primary" ? "primary" : "ghost",
      onClick: buttonDetails.actionCallback,
      key: buttonDetails.actionMsg
    }, buttonDetails.actionMsg);
  }))), /* @__PURE__ */ import_react.default.createElement(import_GlobalHttp404ErrorPage.StyledVideoContainer, null, /* @__PURE__ */ import_react.default.createElement(import_GlobalHttp404ErrorPage.StyledVideo, {
    ref: videoRef,
    "aria-hidden": true,
    id: "video",
    muted: true,
    autoPlay: true,
    loop: true,
    poster: "https://cdn.digital.greatminds.org/dp-assets/dp-images/stan_404_glitch-poster.webp"
  }, /* @__PURE__ */ import_react.default.createElement("source", {
    src: "https://cdn.digital.greatminds.org/dp-assets/dp-media/stan_404_glitch.mp4",
    type: "video/mp4"
  }), /* @__PURE__ */ import_react.default.createElement("track", {
    src: "",
    kind: "captions",
    label: "english_captions"
  })), /* @__PURE__ */ import_react.default.createElement(import_Tooltip.Tooltip, {
    value: videoPlayStatus,
    includeScreenReaderOnlyText: false
  }, /* @__PURE__ */ import_react.default.createElement(import_GlobalHttp404ErrorPage.StyledPlayPauseButton, {
    "data-testId": "playPauseButton",
    onClick: playPauseVideo,
    icon: videoPlaying ? "pause" : "play-fill",
    variant: "ghost",
    circle: true,
    size: "40px",
    "aria-label": "Pause Animation"
  })), /* @__PURE__ */ import_react.default.createElement(import_ScreenReaderOnlyText.ScreenReaderOnlyText, {
    "aria-live": "assertive",
    text: videoPlayStatus
  })));
};
var GlobalHttp404ErrorPage_component_default = GlobalHttp404ErrorPage;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  GlobalHttp404ErrorPage
});
//# sourceMappingURL=GlobalHttp404ErrorPage.component.js.map